export default __webpack_public_path__ + "media/color/etn-3c8ade06.svg";